<agpr-dialog-container
    [id]="id"
    class="agpr-removeFromListsConfirmDialog"
    heading="Discover.distributionReport.recipient.removeFromListsConfirmDialog.header"
    (close)="cancel()"
>
    <div class="agpr-removeFromListsConfirmDialog-text">
        {{ 'Discover.distributionReport.recipient.removeFromListsConfirmDialog.text1' | localize }}
    </div>
    <div class="agpr-removeFromListsConfirmDialog-text">
        {{ 'Discover.distributionReport.recipient.removeFromListsConfirmDialog.text2' | localize }}
    </div>
    <agpr-scroll-panel>
        <ul class="agpr-removeFromListsConfirmDialog-list">
            @for(row of lists; track row.id){
                <li class="agpr-removeFromListsConfirmDialog-listItem">
                  <agpr-checkbox
                    class="agpr-removeFromListsConfirmDialog-checkbox"
                    [binary]="true"
                    [label]="row.label"
                    [(ngModel)]="row.checked"
                    (ngModelChange)="updateSelectedLists(row)"
                  ></agpr-checkbox>
                </li>
            }
          </ul>
    </agpr-scroll-panel>
    <ng-template #footerLeft>
        <agpr-button
            label="Core.button.cancel"
            [style]="buttonTypesEnum.secondary"
            (click)="cancel()"
        ></agpr-button>
    </ng-template>

    <ng-template #footerRight>
        <agpr-button
            [style]="buttonTypesEnum.primary"
            label="Core.button.remove"
            [disabled]="selectedLists.size === 0"
            (click)="remove()"
        ></agpr-button>
    </ng-template>
</agpr-dialog-container>
